import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';


function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: "90%",
    maxWidth: '1200px',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowX: 'auto'
  },
}));

export default function CreditNoteNotTransmited() {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [facturas, setFacturas] = React.useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFacturas  = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/consultar-factura-no-transmitida', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        }
    })
        .then(response => {
            return response.json();
        })
        .then(data => {
            setFacturas(data);
            console.log(data);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
  }

  useEffect(() => {
    if(open){
        getFacturas();
    }
  },[open]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
};

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">Facturas electronicas que no se han transmitido</h2>
      <p id="simple-modal-description">
        A continuación se muestra una lista de facturas que no se han transmitido.
      </p>
      <div style={{ maxHeight: '400px', overflow: 'auto', overflowX: 'auto' }}>
      <table className="table table-striped">
        <thead style={{textAlign: "center"}}>
            <tr>
                <th>DOCS N°</th>
                <th>FECHA EMISION</th>
                <th>FECHA VENCIMIENTO</th>
                <th>TIPO DE FACTURA</th>
                <th>NOTA CRÉDITO</th>
                <th>CLIENTE</th>
                <th>DOCUMENTO</th>
                <th>DOCUMENTO DEL PACIENTE</th>
                <th>NOMBRE DEL PACIENTE</th>
                <th>TOTAL</th>
            </tr>
         </thead>
         <tbody style={{textAlign: "center"}}>
            {facturas.map((item, index) => (
                <tr key={index}>
                    <td>{item.num_fac_ter}</td>
                    <td>{formatDate(item.fecha_emision)}</td>
                    <td>{formatDate(item.vencimiento)}</td>
                    <td>{item.factura_tipo_fe}</td>
                    <td>{item.nota_credito ? "Aplica" : "No Aplica"}</td>
                    <td>{item.nombre_facturado}</td>
                    <td>{item.num_documento}</td>
                    <td>{item.documento_paciente_facturado}</td>
                    <td>{item.nombre_paciente_facturado}</td>
                    <td>{item.total}</td>
                </tr>
                ))}
            </tbody>
      </table>
      </div>

    </div>
  );

  return (
    <div>
      <Button 
        size="sm"
        color="primary"
        style={{ marginLeft: 30, marginTop: 20}}
        onClick={handleOpen}>
            Ver Facturas No Transmitidas
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}